import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import endPoints from '../const/endPoints';
import { createCodeChallenge, generateCodeVerifier, generateRandomAlphaNumericString } from './authenticationProtocol';
import convertPayloadToQueryParams from './convertPayloadToQueryParams';
const formatAuthRequest = ({ baseURL, clientId, redirectURI, loginHintURL, scope, navigateTo, idTokenHint, codeVerifierPrefix }) => {
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = createCodeChallenge(codeVerifier);
    if (codeVerifierPrefix) {
        sessionStorage.setItem(`${codeVerifierPrefix}-codeVerifier`, codeVerifier);
    }
    else {
        sessionStorage.setItem(`codeVerifier`, codeVerifier);
    }
    const state = generateRandomAlphaNumericString(8);
    const nonce = generateRandomAlphaNumericString(8);
    const oauthRedirectUri = `${baseURL}${endPoints.AUTHORIZE}`;
    const requestBody = {
        code_challenge: codeChallenge,
        scope: scope || 'read write',
        response_type: 'code',
        client_id: clientId,
        ui_locales: getLanguageFromStorage(),
        redirect_uri: redirectURI,
        state,
        code_challenge_method: 'S256',
        login_hint: loginHintURL ? btoa(loginHintURL) : '',
        nonce,
        id_token_hint: idTokenHint || ''
    };
    if (scope && navigateTo) {
        sessionStorage.setItem(state, navigateTo);
    }
    return {
        oauthRedirectUri,
        requestBodyQueryParams: convertPayloadToQueryParams(requestBody)
    };
};
export default formatAuthRequest;
